import v3ApiClient from "./client";

const AIRCRAFT_BASE_PATH = "/v3/aircraft";

export const aircraftApi = {
    getAircraftList: (params = {}) => v3ApiClient.get(AIRCRAFT_BASE_PATH, { params }),
};

export default aircraftApi;
